import { format } from 'date-fns';
import { useCallback } from 'react';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

export const useInHandDateStorageFormat = () => {
  const hasIhdTimezoneFix = useUserHasFeature(Feature.IhdTimezoneFix);

  return useCallback(
    (date: Date): string => {
      if (!hasIhdTimezoneFix) {
        return date.toISOString();
      }
      const midnight = new Date(date);
      midnight.setHours(0, 0, 0, 0);
      return format(midnight, "yyyy-MM-dd'T'HH:mm:ss");
    },
    [hasIhdTimezoneFix]
  );
};
